import type { SlateBlock, QuoteBlock, CodeBlock } from '@atlas/renderer';

export default function isMultiLineTextBlock(block: SlateBlock): block is MultiLineTextBlock {
    return (MULTI_LINE_TEXT_BLOCK_TYPES as Array<SlateBlock['type']>).includes(block.type);
}

// #region Helpers

export const MULTI_LINE_TEXT_BLOCK_TYPES: Array<MultiLineTextBlock['type']> = ['block-quote', 'code-block'];

// #endregion

// #region Types

export type MultiLineTextBlock = QuoteBlock | CodeBlock;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isMultiLineTextBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
